import syncApi from './syncApi';

/*
 * PIM approval workflow client.
 *
 * Claim and decision take gate ids rather than (sku, gate) pairs: gates are
 * scoped — pricing per market, enrichment per locale group — so one product can
 * hold several rows of the same gate.
 */

const base = '/pim/workflow';

export const listGates = () => syncApi.get(`${base}/gates`).then((r) => r.data);

export const getWorkflowSummary = () => syncApi.get(`${base}/summary`).then((r) => r.data);

export const getQueue = (params) => syncApi.get(`${base}/queue`, { params }).then((r) => r.data);

export const getProductGates = (sku) =>
  syncApi.get(`${base}/products/${encodeURIComponent(sku)}/gates`).then((r) => r.data);

export const refreshProductGates = (sku) =>
  syncApi.post(`${base}/products/${encodeURIComponent(sku)}/refresh`).then((r) => r.data);

// `version` becomes an If-Match header so two approvers cannot silently
// overwrite each other's decision.
const ifMatch = (version) => (version ? { headers: { 'If-Match': String(version) } } : undefined);

export const claimGate = (gateId, version) =>
  syncApi.post(`${base}/gates/${gateId}/claim`, null, ifMatch(version)).then((r) => r.data);

export const releaseGate = (gateId) =>
  syncApi.post(`${base}/gates/${gateId}/release`).then((r) => r.data);

export const assignGate = (gateId, userId) =>
  syncApi.post(`${base}/gates/${gateId}/assign`, { user_id: userId }).then((r) => r.data);

export const decideGate = (gateId, action, comment, version) =>
  syncApi
    .post(`${base}/gates/${gateId}/decision`, { action, comment }, ifMatch(version))
    .then((r) => r.data);

export const bulkDecide = (gateIds, action, comment) =>
  syncApi
    .post(`${base}/decisions/bulk`, { gate_ids: gateIds, action, comment })
    .then((r) => r.data);

// ── Assignment rules (category x gate -> approver) ──
export const listAssignmentRules = (gate) =>
  syncApi.get(`${base}/assignment-rules`, { params: gate ? { gate } : {} }).then((r) => r.data);

export const createAssignmentRule = (payload) =>
  syncApi.post(`${base}/assignment-rules`, payload).then((r) => r.data);

export const updateAssignmentRule = (id, payload) =>
  syncApi.put(`${base}/assignment-rules/${id}`, payload).then((r) => r.data);

export const deleteAssignmentRule = (id) =>
  syncApi.delete(`${base}/assignment-rules/${id}`).then((r) => r.data);

export const reapplyAssignmentRules = (gate) =>
  syncApi
    .post(`${base}/assignment-rules/reapply`, null, { params: gate ? { gate } : {} })
    .then((r) => r.data);
